var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-element',{style:({
  margin: '0 auto',
})},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Wertungsübersicht")]),_c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"Wertung"}},[_c('h2',{staticClass:"wertungfont"},[_vm._v("T: "+_vm._s(_vm.technik)+" / P: "+_vm._s(_vm.praesi))])])])}
var staticRenderFns = []

export { render, staticRenderFns }